import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

import { FormatServerDate, client, errorValidation } from "./service.js";

export async function getPayments({
    page,
    limit,
    // merchantId,
    paymentDateStart,
    paymentDateEnd,
    paymentDateType,
    provider,
    type,
    amountMin,
    amountMax,
    amountType,
    imeiRepeated,
    referenceId,
    rainRefund,
}) {
    try {
        let payments = await axios.Get({
            url: `${adminUrl}/report/payments`,
            params: {
                page: page || 0,
                limit: limit || 0,
                // merchantId: merchantId || '',
                paymentDateStart: FormatServerDate(paymentDateStart) || '',
                paymentDateEnd: paymentDateEnd || '',
                paymentDateType: paymentDateType || '',
                provider: provider || '',
                type: type || '',
                amountMin: amountMin || '',
                amountMax: amountMax || '',
                amountType: amountType || '',
                bookingId: referenceId || '',
                rainRefund: rainRefund || ''
            }
        });

        if (payments.statusCode !== 200) {
            return { error: payments.message };
        }

        return { data: payments.data };
    } catch (e) {
        return { error: e.response.data };
    }
}
export async function getPaymentSummary({
    paymentDateStart,
    paymentDateEnd,
    paymentDateType,
    provider,
    type,
    amountMin,
    amountMax,
    amountType,
    imeiRepeated,
    referenceId,
    rainRefund
}) {
    try {
        let payments = await axios.Get({
            url: `${adminUrl}/report/payments-summary`,
            params: {
                paymentDateStart: FormatServerDate(paymentDateStart) || '',
                paymentDateEnd: paymentDateEnd || '',
                paymentDateType: paymentDateType || '',
                provider: provider || '',
                type: type || '',
                amountMin: amountMin || '',
                amountMax: amountMax || '',
                amountType: amountType || '',
                bookingId: referenceId || '',
                rainRefund: rainRefund || ''
            }
        });

        if (payments.statusCode !== 200) {
            return { error: payments.message };
        }

        return { data: payments.data };
    } catch (e) {
        return { error: e.response.data };
    }
}